var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19835 0L3.71901 2.5L6.19835 5L8.67769 2.5L6.19835 0ZM8.67769 2.5L11.157 5L13.6364 2.5L11.157 0L8.67769 2.5ZM13.6364 2.5L16.1157 5L18.595 2.5L16.1157 0L13.6364 2.5ZM18.595 2.5L21.0744 5L23.5537 2.5L21.0744 0L18.595 2.5ZM21.0744 5H0V30H27.2727V5H21.0744ZM2.47934 7.5H24.7934V27.5H17.3554V21.25H9.91736V27.5H2.47934V7.5ZM4.95868 10V12.5H7.43802V10H4.95868ZM9.91736 10V12.5H12.3967V10H9.91736ZM14.876 10V12.5H17.3554V10H14.876ZM19.8347 10V12.5H22.3141V10H19.8347ZM4.95868 13.75V16.25H7.43802V13.75H4.95868ZM9.91736 13.75V16.25H12.3967V13.75H9.91736ZM14.876 13.75V16.25H17.3554V13.75H14.876ZM19.8347 13.75V16.25H22.3141V13.75H19.8347ZM4.95868 17.5V20H7.43802V17.5H4.95868ZM9.91736 17.5V20H12.3967V17.5H9.91736ZM14.876 17.5V20H17.3554V17.5H14.876ZM19.8347 17.5V20H22.3141V17.5H19.8347ZM4.95868 21.25V23.75H7.43802V21.25H4.95868ZM19.8347 21.25V23.75H22.3141V21.25H19.8347ZM12.3967 23.75H14.876V27.5H12.3967V23.75Z",
    fill: "#240b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartDark);
export default __webpack_public_path__ + "static/media/apart_dark.a9baecce9d251b088f636e9df92ea223.svg";
export { ForwardRef as ReactComponent };